import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'
import { FaArrowLeft } from 'react-icons/fa'
import { FormattedMessage } from 'react-intl';
import { useQuery } from '../../../../utils/hooks/useQuery';

const AppHeader = ({ image, bootstrap, children, history, redirect }) => {
  const [active, setActive] = useState('');
  const query = useQuery();

  const logOut = (e) => {
    e.preventDefault();
    const urlParams = new URLSearchParams(window.location.href);
    localStorage.removeItem('jwt')
    const logoutUrl = window.AppENV.pass.logoutURL.replace('{CP}', urlParams.get('cp')) + '?url=' + urlParams.get('return_url');
    window.location.href = logoutUrl
  }

  const handleGoBack = (e) => {
    e.preventDefault();
    document.body.classList.remove('lock-scroll');
    return history.goBack();
  };

  const handleToggle = (e) => {
    e.preventDefault();
    const action = (active === 'active') ? '' : 'active';
    setActive(action);
    document.body.classList.toggle('lock-scroll');
  }

  return (
    <header className={`AppHeader-container tbx-header ${active}`}>
      <ul className="menu">
        <li className="back">
          <a onClick={handleGoBack} className="go-back" href="#">
            <FaArrowLeft color="#FFFFFF" size={32} />
          </a>
        </li>
        <li className="logo">
          <img
            onClick={redirect}
            src={image.src}
            alt={image.alt}
            width={100}
            height={60}
          />
          {children && (
            <div
              className={classnames('AppHeader-body', Boolean(image) && {
                left: image.position === 'right',
                right: image.position === 'left',
              })}
            >
              {children}
            </div>
          )}
        </li>
        <li className="item button">
          {bootstrap?.redirectAfterLogin && (
            <a className="logoutButton" onClick={logOut}>
              <FormattedMessage id="logout" />
            </a>
          )}
        </li>
        <li className="toggle">
          {bootstrap?.redirectAfterLogin && (
            <a href="#" onClick={handleToggle}>
              <div />
              <div />
            </a>
          )}
        </li>
      </ul>
    </header>
  )
};

AppHeader.defaultProps = {
  image: null
};

AppHeader.propTypes = {
  image: PropTypes.shape({
    position: PropTypes.oneOf(['left', 'right']).isRequired,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string
  }),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  bootstrap: PropTypes.object,
  history: PropTypes.object,
};

export default AppHeader;
